import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';
import { TypeExpertiseInputComponent } from './type-expertise-input/type-expertise-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { ContactInputComponent } from './contact-input/contact-input.component';
import { ContactViewComponent } from './contact-view/contact-view.component';
import { UserInputComponent } from './user-input/user-input.component';
import { UserListComponent } from './user-list/user-list.component';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { ButtonModule } from 'primeng/button';
import { ExpertiseInputComponent } from './expertise-input/expertise-input.component';

@NgModule({
  declarations: [TypeExpertiseInputComponent, ContactInputComponent, ContactViewComponent, UserInputComponent, UserListComponent, ExpertiseInputComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatIconModule,
    MatListModule,
    ButtonModule,
    RouterModule
  ],
  exports: [
  TypeExpertiseInputComponent,
  ContactInputComponent,
  ContactViewComponent,
  UserInputComponent,
  UserListComponent,
  ExpertiseInputComponent
  ]
})
export class ComponentsModule { }
